import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { I18nService } from '@recruitee/i18n';
import { DialogService, NotificationsController } from '@recruitee/user-interface';

@Injectable({ providedIn: 'root' })
export class CoverLetterUiService {
  constructor(
    private notifyCtrl: NotificationsController,
    private i18n: I18nService,
    private dialogService: DialogService,
  ) {}

  public promptReplaceTextWithFile(): Observable<boolean> {
    return this.dialogService.information({
      title: this.i18n.translate(
        'app.candidate.cover_letter_confirmation.replace_existing.title_v2',
      ),
      message: this.i18n.translate(
        'app.candidate.cover_letter_confirmation.replace_existing.description',
      ),
      agreeLabel: this.i18n.translate(
        'app.candidate.cover_letter_confirmation.replace_with_file.agree_label',
      ),
    });
  }

  public promptReplaceExistingFile(): Observable<boolean> {
    return this.dialogService.information({
      title: this.i18n.translate(
        'app.candidate.cover_letter_confirmation.replace_existing.title_v2',
      ),
      message: this.i18n.translate(
        'app.candidate.cover_letter_confirmation.replace_existing.description',
      ),
      agreeLabel: this.i18n.translate(
        'app.candidate.cover_letter_confirmation.replace_existing.agree_label',
      ),
    });
  }

  public promptDelete(): Observable<boolean> {
    return this.dialogService.information({
      title: this.i18n.translate('app.candidate.cover_letter_confirmation.delete.title'),
      message: this.i18n.translate('app.candidate.cover_letter_confirmation.delete.description'),
      agreeLabel: this.i18n.translate('app.candidate.cover_letter_confirmation.delete.agree_label'),
    });
  }

  public notifyDelete(): void {
    this.notifyCtrl.success(this.i18n.translate('app.candidate.cover_letter_deleted'));
  }

  public notifyFileUploaded(): void {
    this.notifyCtrl.success(this.i18n.translate('app.candidate.cover_letter_file_uploaded'));
  }

  public notifyAdded(): void {
    this.notifyCtrl.success(this.i18n.translate('app.candidate.cover_letter_added'));
  }

  public notifyFileUploadFailed(payload: { error: string | undefined }): void {
    this.notifyCtrl.error(
      payload.error ?? this.i18n.translate('app.common.errors.server_error_message'),
    );
  }

  public promptUpdateCoverLetterWithAttachment(fileName: string): Observable<boolean> {
    return this.dialogService.information({
      title: this.i18n.translate(
        'app.candidate.cover_letter_confirmation.replace_file_with_attachment.title',
      ),
      message: this.i18n.interpolate(
        this.i18n.translate(
          'app.candidate.cover_letter_confirmation.replace_file_with_attachment.description',
        ),
        { fileName },
      ),
      agreeLabel: this.i18n.translate(
        'app.candidate.cover_letter_confirmation.replace_file_with_attachment.agree_label',
      ),
    });
  }

  public notifyUpdatedWithAttachment(): void {
    this.notifyCtrl.success(this.i18n.translate('app.candidate.cover_letter_updated'));
  }
}
